import styled from 'styled-components'
import { colors } from '../../styleConstants'
import { Button } from '../common/Button'

export const LineButton = styled(({ href, ...rest }) => (
  <Button look="white" iconLeft={<img src="/static/line-logo.png" width="24" height="24" />} href={href} {...rest} />
))`
  color: ${colors.white};
  background-color: ${colors.line.base};
  width: 20rem;

  &:hover,
  &:focus {
    background-color: ${colors.line.hover};
  }

  &:active {
    background-color: ${colors.line.press};
  }
`
